// Sorting/grouping helpers for the School Program Attendance sheet.
//
// Rows are ordered by school, then by course abbreviation (numeric-aware, e.g.
// SR150 before SR350), then by student name. Rows sharing the same school +
// course form a group; a blank separator row is rendered between groups.

const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});

export function compareRows(a, b) {
  const schoolDiff = collator.compare(a.school_name || "", b.school_name || "");
  if (schoolDiff !== 0) return schoolDiff;

  const codeDiff = collator.compare(a.course_code || "", b.course_code || "");
  if (codeDiff !== 0) return codeDiff;

  const abbrDiff = collator.compare(a.course_abbr || "", b.course_abbr || "");
  if (abbrDiff !== 0) return abbrDiff;

  return collator.compare(a.student_name || "", b.student_name || "");
}

/**
 * Returns the rows in display order (school -> course -> student name)
 * without any grouping metadata. Used for the on-screen table.
 */
export function sortRows(rows) {
  if (!Array.isArray(rows)) return [];
  return [...rows].sort(compareRows);
}

/**
 * Returns the rows sorted in display order. Each row is tagged with
 * `__groupStart` = true when it begins a new school + course group (used to
 * render the blank separator row above it on screen / in the export).
 */
export function sortAndGroup(rows) {
  if (!Array.isArray(rows)) return [];

  const sorted = [...rows].sort(compareRows);

  let prevKey = null;
  return sorted.map((row) => {
    // Group on the school + course so distinct courses are always separated,
    // even when abbreviations collide across schools.
    const key = `${row.school_information_id ?? row.school_name ?? ""}|${
      row.course_code ?? row.course_abbr ?? ""
    }`;
    const groupStart = prevKey !== null && prevKey !== key;
    prevKey = key;
    return { ...row, __groupStart: groupStart };
  });
}
